@if (question$ | async; as question) {
  <lib-question-display [question]="question.value" />
  <ion-radio-group
    [value]="currentAnswer$ | async"
    (ionChange)="onSelect($event.detail.value)"
  >
    <div class="radio-group-wrapper">
      @for (option of getOptions(); track option) {
        <ion-item>
          <ion-radio
            name="value"
            [value]="option"
            [disabled]="disabled()"
            labelPlacement="end"
            justify="start"
          >
            <div class="radio-label" [innerHTML]="getOptionLabel(option)"></div>
          </ion-radio>
        </ion-item>
      }
    </div>
  </ion-radio-group>
}
